import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

export const fetchIndustrysectorchildItems = createAsyncThunk(
  "industrysectorcategories/fetchChild",
  async (_, thunkAPI) => {
    const res = await fetch(
      `${process.env.REACT_APP_API_BASE}/api/industrysectorchild`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "partner",
        },
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
